const FNV_OFFSET = 0x811c9dc5;
const FNV_PRIME = 0x01000193;

/** Small, stable 32-bit hash (FNV-1a) for deterministic visuals such as generated covers. Not for security. */
export function hashString(value: string): number {
  let hash = FNV_OFFSET;
  for (let i = 0; i < value.length; i++) {
    hash ^= value.charCodeAt(i);
    hash = Math.imul(hash, FNV_PRIME);
  }
  return hash >>> 0;
}

/** Deterministic pseudo-random numbers in [0, 1) from a seed (mulberry32). */
export function seededRandom(seed: number): () => number {
  let state = seed >>> 0;
  return () => {
    state = (state + 0x6d2b79f5) >>> 0;
    let t = state;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4_294_967_296;
  };
}
